/* eslint-disable prefer-template */
import { Grid } from '@material-ui/core';
import Chart from 'chart.js';
import i18n from 'i18n';
import { MonthlyEnvironmentsCostGraphFields } from 'modules/monitor/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import palette from 'theme/palette';
import { defaultGraphConfig } from 'utils/graphs';
import { formatCurrency } from 'utils/helpers';

interface MonthlyEnvironmentsCostGraphContentProps {
  monthlyEnvironmentsCostGraphFields: MonthlyEnvironmentsCostGraphFields;
}

const MonthlyEnvironmentsCostGraphContent = ({
  monthlyEnvironmentsCostGraphFields,
}: MonthlyEnvironmentsCostGraphContentProps) => {
  const containerRef = React.useRef<HTMLCanvasElement>(null);
  const labels = monthlyEnvironmentsCostGraphFields?.metrics.map(
    item => item.month
  );

  const config = defaultGraphConfig({
    labels,
    datasets: [
      {
        data: monthlyEnvironmentsCostGraphFields?.metrics?.map(item => ({
          x: item.month,
          y: item.cost,
          custom: {
            licenses: item.total_licenses,
            totalInstances: item.total_instances,
            totalEnvironments: item.total_environments,
          },
        })),
        backgroundColor: palette.deepBlue,
        borderColor: palette.deepBlue,
        fill: false,
        tension: 0.4,
        barThickness: 50,
      },
    ],
  });
  config.type = 'bar';

  config.options.tooltips.callbacks = {
    label(tooltipItem) {
      return `${i18n.t('COSTS_PAGE.COST_KEY')}: ${formatCurrency(
        tooltipItem.value
      )}`;
    },
    afterLabel(tooltipItem, data) {
      const dataPoint =
        data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
      return [
        `${i18n.t('ENVIRONMENTS_KEY')}: ${dataPoint.custom?.totalEnvironments ??
          '7'}`,
        `${i18n.t('LICENSES_KEY')}: ${dataPoint.custom?.licenses ?? '-'}`,
        `${i18n.t('INSTANCES_KEY')}: ${dataPoint.custom?.totalInstances ??
          '-'}`,
      ];
    },
  };
  config.options.scales.xAxes[0].ticks.display = true;
  config.options.scales.yAxes[0].ticks.display = true;

  React.useEffect(() => {
    let chart;

    if (containerRef.current) {
      chart = new Chart(containerRef.current, config);
    }
    return () => chart?.destroy();
  }, [containerRef, config]);

  return (
    <Grid container>
      <canvas ref={containerRef} width="auto" height="100"></canvas>
    </Grid>
  );
};

const mapStateToProps = ({
  monitor: { monthlyEnvironmentsCostGraphFields },
}: ApplicationState) => ({ monthlyEnvironmentsCostGraphFields });

export default connect(
  mapStateToProps,
  {}
)(MonthlyEnvironmentsCostGraphContent);
